import { FaExclamationCircle } from "react-icons/fa";

const EarlyCareerResearcher = () => {
  return (
    <div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        fontSize: "1rem",
        color: "#555",
        gap: "10px"
      }}
    >
      <FaExclamationCircle style={{ fontSize: "1rem", color: "black" }} />
      Under Development
    </div>
  );
};
export default EarlyCareerResearcher;